// src/pages/settings/TemplatesTab.tsx
import React, { useState } from "react";
import { Card, Tabs } from "antd";
import {
	BranchesOutlined,
	FileTextOutlined,
	BookOutlined,
	BarChartOutlined,
	AppstoreOutlined,
	BellOutlined,
	ExperimentOutlined,
} from "@ant-design/icons";
import WorkflowsTab from "./templates/consultationGuidance/WorkflowsTab";
import { FormBuilder } from "./templates/forms/FormPage";
import NoteTemplatesPage from "./templates/appointmentNotes/NoteTemplatesPage";
import { ReportPage } from "./templates/consultReports/ReportPage";
import TreatmentPlanTemplatesPage from "./templates/treatmentPlans/TreatmentPlanTemplatesPage";
import { TemplatePage } from "./templates/notifications/TemplatePage";
import ProtocolManagementPage from "./templates/protocols/ProtocolManagementPage";
import { hasFeature } from "../../utils/subscriptions/subscriptionService";

const TemplatesTab: React.FC = () => {
	const isPeptideOnly = hasFeature("healthcare.peptide") && !hasFeature("healthcare");
	const hasLab = hasFeature("laboratory");

	const [activeTab, setActiveTab] = useState<string>(isPeptideOnly ? "forms" : "workflows");

	const allTabs = [
		{
			key: "workflows",
			hidden: isPeptideOnly,
			label: (
				<span>
					<BranchesOutlined /> Consultation Workflows
				</span>
			),
			children: <WorkflowsTab />,
		},
		{
			key: "forms",
			label: (
				<span>
					<FileTextOutlined /> Forms
				</span>
			),
			children: <FormBuilder embedded />,
		},
		{
			key: "notes",
			hidden: isPeptideOnly,
			label: (
				<span>
					<BookOutlined /> Notes
				</span>
			),
			children: <NoteTemplatesPage embedded />,
		},
		{
			key: "reports",
			hidden: isPeptideOnly,
			label: (
				<span>
					<BarChartOutlined /> Reports
				</span>
			),
			children: <ReportPage embedded />,
		},
		{
			key: "treatment-plans",
			hidden: isPeptideOnly,
			label: (
				<span>
					<AppstoreOutlined /> Treatment Plans
				</span>
			),
			children: <TreatmentPlanTemplatesPage />,
		},
		{
			key: "notifications",
			label: (
				<span>
					<BellOutlined /> Notifications
				</span>
			),
			children: <TemplatePage embedded />,
		},
		{
			key: "lab-protocols",
			hidden: !hasLab,
			label: (
				<span>
					<ExperimentOutlined /> Lab Protocols
				</span>
			),
			children: <ProtocolManagementPage />,
		},
	];

	const tabItems = allTabs.filter((t) => !t.hidden);

	return (
		<Tabs
			activeKey={activeTab}
			onChange={setActiveTab}
			size="small"
			items={tabItems}
			destroyInactiveTabPane={false}
		/>
	);
};

export default TemplatesTab;
